<template>
    <div class="rows segment-item-wrapper" :class="{ selected }">
        <div class="row segment-list" @click="toggleCheckbox">
            <span>
                <a-checkbox :checked="isChecked" class="segment-checkbox" />
            </span>
            <span class="segment-item">
                <div class="segment-item-name">
                    {{ row.name }}
                </div>
                <div class="">
                    {{ !!row.users ? row.users.length + " users" : "" }}
                </div>
            </span>
        </div>
    </div>
</template>

<script>
import log2 from "../../../utils/log2";

const log = log2("QueryRowItem");
export default {
    name: "VisitorAddSegment",
    components: {},
    props: {
        row: {
            type: Object,
            required: true,
        },
        onSelectChanged: {
            type: Function,
            required: false,
            default: () => {},
        },
        selectedSegments: {
            type: Array,
            required: true,
            default: () => [],
        },
        selected: Boolean,
    },
    data() {
        return {
            hovered: false,
            isChecked: this.selected,
        };
    },
    mounted() {
        const checkItem = this.selectedSegments.findIndex((x) => {
            return x._id === this.row._id;
        });
        this.isChecked = checkItem > -1;
    },
    methods: {
        changeHoverState(hovered) {
            this.hovered = hovered;
        },
        toggleCheckbox() {
            this.isChecked = !this.isChecked;
            this.onSelectChanged(this.row);
        },
    },
    watch: {
        selectedSegments(newValue) {
            const checkItem = this.selectedSegments.findIndex((x) => {
                return x._id === this.row._id;
            });
            this.isChecked = checkItem > -1;
        },
        selected(newVal) {
            this.isChecked = newVal;
        },
    },
};
</script>

<style lang="scss">
.segment-item-wrapper {
    &.selected {
        .segment-list {
            background: #f3f5f6;
        }
    }

    .segment-list {
        margin: 0px 10px 0px 10px;
        border-top: 1px solid #c6cdd4;
        display: flex;
        align-items: center;
        cursor: pointer;
        background: #fff;

        &:hover {
            opacity: 0.8;
        }
    }

    .segment-checkbox {
        margin-left: 10px;
    }

    .segment-item {
        margin: 5px 0px 0px 10px;
    }

    .segment-item-name {
        font-size: 16px;
        font-weight: bold;
        color: #000000;
    }
}
</style>
